/* eslint-disable no-restricted-globals */
import { UseAuth } from "hook/auth-hook"
import { Container, Nav, Image, Navbar, Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { ReactComponent as SVGIcon } from "../../assets/images/logo-is-compras.svg"
import { useEffect, useState } from "react"
import { RestUseCase } from "service/api/rest/rest-usecase"
import { getEnv } from "helper/window-helper";
import { clearAuthLocalStorage } from "helper/logout-helper"
import { FaRegUser } from "react-icons/fa"
import { ModalUpdateuserInfo } from "pages/layout/safety/components/modal/update-user-info-modal"
import { NotificacaoSino } from "./notificacao-sino-component"
import React from "react"
import { HeaderUserInfo } from "@interfaces/communs/header-user-info"


export const TopHeader = React.memo(() => {

    const { updateIsLoggedIn, loggedUserData } = UseAuth()
    const avatar = "https://gravatar.com/avatar/9d6cbf90c3a007688af389adf8ca038d?s=400&d=identicon&r=x"

    let navigate = useNavigate()

    const userInfoCoded = localStorage.getItem(getEnv('REACT_APP_LOCALSTORAGE_INFO_CHECK'));
    var userInfo: HeaderUserInfo | undefined;

    if (userInfoCoded) {
        try {
            const decoded = window.atob(userInfoCoded);
            userInfo = JSON.parse(decoded) as HeaderUserInfo;
        } catch (err) {
            userInfo = undefined;
        }
    }

    function handleLogout(): void {
        clearAuthLocalStorage()

        updateIsLoggedIn(false)
        navigate("/")
        location.reload()
    }

    const ENDPOINT_COMPANY = getEnv("REACT_APP_END_POINT_COMPANIES")!;
    const ENDPOINT_USER = getEnv("REACT_APP_END_POINT_USER")!;
    const [user, updateUser] = useState<any>();

    const [usuarioPrecisaAtualizarDados, updateUsuarioPrecisaAtualizarDados] = useState<boolean>(false)
    const [showModalUpdateuserInfo, updateShowModalUpdateuserInfo] = useState<boolean>(false)
    const openModalUpdateuserInfo = () => { updateShowModalUpdateuserInfo(true) }
    const closeModalUpdateuserInfo = () => { updateShowModalUpdateuserInfo(false) }

    async function fetchData() {
        const userResp = await new RestUseCase(`${ENDPOINT_USER}/${loggedUserData?.id}`).GetById();
        const companyResp = await new RestUseCase(`${ENDPOINT_COMPANY}/${loggedUserData?.companyId}`).GetById();
        updateUser(userResp.body);
        var info: HeaderUserInfo = { id: userResp.body.id, nome: userResp.body.nome, nomeEmpresa: companyResp.body.nomeFantasia }
        localStorage.setItem(getEnv('REACT_APP_LOCALSTORAGE_INFO_CHECK'), window.btoa(JSON.stringify(info)));
    }

    useEffect(() => {
        if (!loggedUserData) return;

        if (userInfo === null || userInfo === undefined)
            fetchData();
        else if (loggedUserData?.id !== userInfo?.id)
            fetchData();

    }, [loggedUserData?.id]);

    useEffect(() => {
        if (user?.usuarioPrecisaAtualizarDados) {
            updateUsuarioPrecisaAtualizarDados(true)
            openModalUpdateuserInfo()
        }
    }, [user])

    return (
        <>
            <Navbar expand="lg" style={{ backgroundColor: 'rgba(202, 220, 251, 1)' }}>
                <Container>
                    <Navbar.Brand><SVGIcon height={"40px"} /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="firstHeader" />
                    <Navbar.Collapse className="justify-content-end">
                        <NotificacaoSino />
                        <Button onClick={openModalUpdateuserInfo} size="sm" variant="secondary" style={{ marginRight: "15px" }}>
                            <FaRegUser size={15} />
                        </Button>
                        <Navbar.Text>
                            <b>Usuário:</b>{userInfo?.nome}<b> Empresa:</b>{userInfo?.nomeEmpresa}
                        </Navbar.Text>
                        <Image src={avatar} roundedCircle={true} width="40px" height="40px" className="mx-2" />
                        <Nav.Link onClick={() => handleLogout()} style={{ color: "#017BFE" }}>
                            Sair
                        </Nav.Link>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <ModalUpdateuserInfo 
            showModalUpdateuserInfo={showModalUpdateuserInfo}
            openModalUpdateuserInfo={openModalUpdateuserInfo}
            closeModalUpdateuserInfo={closeModalUpdateuserInfo}
            usuarioPrecisaAtualizarDados={usuarioPrecisaAtualizarDados} 
            updateUserInfoOnScreen={fetchData}/>
        </>
    )
});